import { EntityFormType, Transformers } from '@enterprise/common';
import { FormProps } from 'react-final-form';
import { FeatureEntity } from '../../../services/FeatureService';
import { UserEntity } from '../../../core/entity/UserEntity';

export type UserEditFormValues = UserEntity & {
    features?: FeatureEntity[];
    orgId?: string;
    pricingTierId?: number;
    analyticsAccessIds?: number[];
};

export class UserFormType extends EntityFormType<UserEntity> {
    constructor() {
        super(UserEntity);
    }

    buildForm(data: UserEditFormValues, options?: any): Partial<FormProps> | any {
        const initialValues = new Transformers.ToPlainTransformer().transform(data);

        return super.buildForm(initialValues, options);
    }

    getEntity(value: any, options?: any): UserEditFormValues {
        const { features, pricingTierId, analyticsAccessIds, orgId, ...rest } = value;
        return {
            ...new Transformers.ToTypeTransformer(UserEntity).transform(rest),
            orgId,
            features,
            pricingTierId,
            analyticsAccessIds,
        };
    }
}
